import { makeAutoObservable } from "mobx";

class AppStore {
  updateHeaderBtn: JSX.Element | null = null
  isMobile: boolean = false
  isMobileSidebarOpen: boolean = false
  private isInitialized: boolean = false

  constructor() {
    makeAutoObservable(this);
  }

  initializeMobileDetection() {
    if (typeof window !== 'undefined' && !this.isInitialized) {
      this.isInitialized = true;
      this.checkMobileSize();
      window.addEventListener('resize', this.checkMobileSize);
    }
  }

  checkMobileSize = () => {
    if (typeof window !== 'undefined') {
      const isMobileScreen = window.innerWidth <= 768;
      this.setIsMobile(isMobileScreen);
    }
  }

  setIsMobile(isMobile: boolean) {
    this.isMobile = isMobile;
    if (!isMobile && this.isMobileSidebarOpen) {
      this.setMobileSidebarOpen(false);
    }
  }

  getIsMobile() {
    if (typeof window !== 'undefined' && !this.isInitialized) {
      this.initializeMobileDetection();
    }
    return this.isMobile;
  }

  setMobileSidebarOpen(isOpen: boolean) {
    this.isMobileSidebarOpen = isOpen;
  }

  getMobileSidebarOpen() {
    return this.isMobileSidebarOpen;
  }

  toggleMobileSidebar() {
    this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
  }

  setUpdateHeaderBtn(ref: JSX.Element) {
    this.updateHeaderBtn = ref;
  }

  getUpdateHeaderBtn() {
    return this.updateHeaderBtn;
  }

  resetUpdateHeaderBtn() {
    this.updateHeaderBtn = null;
  }
}

export default new AppStore();
